import cn from 'classnames';
import { FC, ReactNode, useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { RenderPreviewSettings } from '@/shared/config';
import { useAppDispatch } from '@/shared/hooks';

import { reportsModel } from '@/entities/reports';
import { useIsPseudoFullscreen } from '@/entities/toolbarMIR';

import {
  MedicalImageRender,
  ViewMIR,
} from '../../../../shared/graphics/medicalImageRender/MedicalImageRender';

import styles from './PanowingsReportRender.module.scss';

type PanowingsReportRenderProps = {
  className?: string;
  children?: ReactNode;
  previewSettings?: RenderPreviewSettings;
};

export const PanowingsReportRender: FC<PanowingsReportRenderProps> = (
  props,
) => {
  const { className, children, previewSettings } = props;

  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const isPseudoFullscreen = useIsPseudoFullscreen();

  useEffect(() => {
    MedicalImageRender.addEventListener('layout', (event) => {
      if (event.mode === 'focus') {
        dispatch(reportsModel.actions.setToolbarActiveControl('view'));
        dispatch(reportsModel.actions.setFocusedMetaImageID(event.id));

        // Update URL with new activeItemID
        if (event.id) {
          searchParams.set('activeItemID', event.id);
        } else {
          searchParams.delete('activeItemID');
        }
        setSearchParams(searchParams);
      }
    });
  }, []);

  return (
    <div
      data-component="panowings-report-render"
      style={{ display: 'contents' }}
    >
      <ViewMIR
        viewName="main"
        id="report_render"
        className={cn(
          styles.container,
          previewSettings?.isPreview ? styles.preview : '',
          isPseudoFullscreen && styles.pseudoFullscreen,
          className,
        )}
      >
        {children}
      </ViewMIR>
    </div>
  );
};
